import { useEffect, useState } from '@wordpress/element'

const useFeaturedPosts = () => {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [featuredPosts, setFeaturedPosts] = useState({
        platform_posts: [],
        thought_leadership_posts: [],
        customer_stories_posts: [],
    })

    useEffect(() => {
        const fetchFeaturedPosts = async () => {
            try {
                const response = await fetch('/wp-json/conapi/v1/featured-posts')
                if (!response.ok) {
                    throw new Error('Failed to fetch data.')
                }
                const data = await response.json()
                setFeaturedPosts(data)
            } catch (err) {
                setError(err.message)
            } finally {
                setLoading(false)
            }
        }

        fetchFeaturedPosts()
    }, [])

    return { featuredPosts, loading, error }
}

export default useFeaturedPosts